import { request } from '@axios-use/react';

import { getUserOpenIdForTiktok } from '@/channels';
import { getTiktokUrl } from './request';

export type CouponInfoItem = {
  productName?: string;
  couponPreviewPath?: string;
  logoPath?: string;
  expireTime?: number;
  couponCode?: string;
  startTime?: number;
};

export const getUserCartListWithoutLoginReqConfig = (params: { page: number; page_size: number }) => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
  return request<{ certificates?: CouponInfoItem[] }>({
    method: 'post',
    baseURL: getTiktokUrl(),
    url: '/douyin/api/v2/get_user_certificates',
    params: { ...params, open_id: getUserOpenIdForTiktok() },
    withCredentials: false,
  });
};
